module.exports = __webpack_public_path__ + "img/IMG-20200714-WA0004.78401c6d.jpg";